import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalService } from 'app/common/services/modal.service';
import { SharingService } from 'app/services/sharing.service';
import { DomainEntityType } from 'app/models/domainentities.model';
import { DomainEntityProvider } from 'app/services/DomainEntityProvider.service';
import { EntitiesList } from './entities-list.page';


@Component({
    selector: 'entities-list',
    templateUrl: './entities-list.page.html'
})
export class CulturalHeritagesList extends EntitiesList {
    
	constructor(_activatedRoute: ActivatedRoute, _router: Router, _entitiesProvider: DomainEntityProvider, _modalService: ModalService, _sharingService: SharingService) {
        super(DomainEntityType.CULTURAL_HERITAGE, _activatedRoute, _router, _entitiesProvider, _modalService, _sharingService);
    }

	public pageTitle() {
		return 'domainEntity.ch.listContentsPageTitle';
	}
	public cardHeaderTitle() {
		return 'domainEntity.ch.listContentsPageCardHeaderTitle';
	}
	public newButtonLabel() {
		return 'domainEntity.ch.addNewButtonLabel';
	}
}
